import { combineReducers } from 'redux';
import courses from './course.reducer';
import courseBuilder from './builder.reducer';

const courseAppReducer = combineReducers({
    courses,
    courseBuilder,
});

export default courseAppReducer;


// WEBPACK FOOTER //
// src/main/content/course/store/reducers/index.js